// extracted by mini-css-extract-plugin
export default {"ButtonCard":"ButtonCard_ButtonCard__9is+A","ButtonLogo":"ButtonCard_ButtonLogo__WSLe7","ButtonIcon":"ButtonCard_ButtonIcon__wBii3","logoContainer":"ButtonCard_logoContainer__U8Dz4"};